import { createSlice } from "@reduxjs/toolkit"

export const flagshipListSlice = createSlice({
	name: "flagshipList",
	initialState: {
		flagship: "",
		errors: [],
	},

	reducers: {
        getFlagship: (state, action) => {
            // console.log(action.payload);
			state.flagship = action.payload
		},
		getFlagshipList: (state, action) => {
			// console.log(action.payload);
			state.flagship = action.payload
		},
		getErrors: (state, action) => {
            // console.log(action.payload);
			state.errors = action.payload
		},
	},
})
export const {getFlagship, getFlagshipList, getErrors} = flagshipListSlice.actions

export default flagshipListSlice.reducer
